<template>
  <div
    class="page-container"
    style="padding-top: 22px">
    <v-dialog
      class="template-pop-up template-pop-up-fix"
      v-model="createPanelOpen">
      <CreatePanelModal
        @close="createPanelOpen = false"
        :panel="selectedPanel" />
    </v-dialog>
    <v-dialog
      class="template-pop-up template-pop-up-fix"
      v-model="createButtonOpen">
      <CreateNewButtonModal
        v-if="createButtonOpen"
        @close="createButtonOpen = false"
        :button="selectedbtn"
        :index="selectedPanelIndex"
        :panelUid="selectedPanelUid" />
    </v-dialog>
    <div
      style="width: 100%; height: 100%; display: flex; flex-direction: column">
      <div
        class="managers mb-2"
        v-if="preview">
        <CueTakeControls :takeAll="true" />
        <PreviewDisplay
          v-for="i in getFramesInUse()"
          :key="i"
          :frameNo="i" />
      </div>
      <div
        class="grid-outer-container"
        style="
          background: var(--v-cardColor-base);
          border-radius: 8px;
          align-items: stretch;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          padding: 12px;
          height: 50px;
        ">
        <div
          style="
            display: flex;
            gap: 8px;
            align-items: start;
            justify-content: space-between;
          ">
          <div
            v-if="controls && tab && deluge.panels[tab] && viewMode === 'grid'"
            @click="
              selectedPanel = deluge.panels[tab];
              createPanelOpen = true;
            "
            style="height: 33px"
            class="ibtn-container mr-2 pa-1 header-icon">
            <v-icon
              size="large"
              class="header-icon">
              mdi-cog
            </v-icon>
          </div>
          <v-tabs
            v-if="viewMode === 'grid' && ((tabs && controls) || props.preSelect.length > 1)"
            show-arrows
            v-model="tab">
            <v-tab
              :color="buttonTextColor"
              :base-color="buttonTextColor"
              :prepend-icon="panel.icon"
              v-for="(panel, panelUid) in filteredPanels"
              :key="panelUid"
              :value="panelUid"
              :text="panel.name"></v-tab>
          </v-tabs>
          <div
            v-if="viewMode !== 'grid' || !controls"
            style="flex-grow: 1"></div>
          <div
            v-if="controlPanelMode"
            class="view-mode-group">
            <div
              @click="viewMode = 'grid'"
              :class="viewMode === 'grid' ? 'ibtn-container-selected' : ''"
              class="ibtn-container pa-1 header-icon view-mode-btn"
              title="Grid View">
              <v-icon
                size="large"
                class="header-icon">
                mdi-view-grid
              </v-icon>
            </div>
            <div
              v-if="multipleFrames"
              @click="viewMode = 'frames'"
              :class="viewMode === 'frames' ? 'ibtn-container-selected' : ''"
              class="ibtn-container pa-1 header-icon view-mode-btn"
              title="Frames View">
              <v-icon
                size="large"
                class="header-icon">
                mdi-view-column
              </v-icon>
            </div>
            <div
              @click="viewMode = 'deck'"
              :class="viewMode === 'deck' ? 'ibtn-container-selected' : ''"
              class="ibtn-container pa-1 header-icon view-mode-btn"
              title="Deck View">
              <v-icon
                size="large"
                class="header-icon">
                mdi-view-sequential
              </v-icon>
            </div>
          </div>
          <div
            v-if="controls && viewMode === 'grid'"
            @click="
              selectedPanel = undefined;
              createPanelOpen = true;
            "
            style="height: 33px"
            class="ibtn-container ml-2 pa-1 header-icon">
            <v-icon
              size="large"
              class="header-icon">
              mdi-plus
            </v-icon>
          </div>
        </div>
        <FramesView v-if="viewMode === 'frames'" />
        <DeckView v-if="viewMode === 'deck'" />
        <div
          v-if="viewMode === 'grid'"
          class="grid-container">
          <div
            class="button-box-outer"
            :class="[
              loadingState ? 'button-unavailable' : 'button-clickable',
              {
                'is-empty': !(
                  tab &&
                  deluge.panels[tab] &&
                  deluge.panels[tab].buttons[i]
                ),
              },
            ]"
            v-for="i in tab && deluge.panels[tab]
              ? deluge.panels[tab].available_slots
              : []"
            @contextmenu.prevent
            @click.left="
              deluge.panels[tab] && deluge.panels[tab].buttons[i]
                ? triggerFromPanel(tab, i)
                : emptyBoxClick(i)
            "
            @click.right="
              deluge.panels[tab] && deluge.panels[tab].buttons[i]
                ? emptyBoxClick(i, deluge.panels[tab].buttons[i])
                : emptyBoxClick(i)
            "
            :style="{
              '--button-color': deluge.panels[tab]?.buttons[i]?.color,
            }">
            <div
              v-if="tab && deluge.panels[tab] && !deluge.panels[tab].buttons[i]"
              @dragover.prevent
              @touchmove.prevent
              @drop="handleDrop(i)"
              @touchend="handleDrop(i)"
              class="box box-empty"
              :class="{ 'control-panel-mode': controlPanelMode }">
              {{ controlPanelMode ? '' : i }}
            </div>
            <div
              v-else-if="tab && deluge.panels[tab]"
              class="button button-box pa-1"
              :draggable="controlPanelMode ? false : true"
              @dragstart="handleDragStart(i)"
              @touchstart="handleDragStart(i)"
              @dragover.prevent
              @touchmove.prevent
              @drop="handleDrop(i)"
              @touchend="handleDrop(i)"
              :style="
                deluge.panels_meta?.index === i &&
                deluge.panels_meta?.panel_uid === tab
                  ? `outline-color: ${deluge.panels[tab].buttons[i].color}; outline-width: 3px;`
                  : ''
              ">
              <div
                style="bottom: 10px"
                class="button-background-highlight"
                :style="`background: linear-gradient(90deg, ${deluge.panels[tab].buttons[i].color} -260%, rgba(0,212,255,0) 57%);`"></div>
              <div
                style="
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 1;
                ">
                <v-progress-circular
                  style="margin-left: -10px; margin-top: -10px"
                  v-if="deluge.panels[tab].buttons[i].loading"
                  size="30"
                  color="primary"
                  indeterminate></v-progress-circular>
              </div>
              <div
                :style="`background-color: ${deluge.panels[tab].buttons[i].color};`"
                class="coloured-panel"></div>
              <div class="content-panel">
                <div
                  :style="{
                    opacity: deluge.panels[tab].buttons[i].loading ? 0.5 : 1,
                  }"
                  style="
                    color: var(--text);
                    margin: 4px;
                    max-height: 100px;
                    overflow: auto;
                    position: relative;
                    font-weight: bolder;
                    text-transform: uppercase;
                    min-height: calc(100% - 8px);
                    z-index: 1000;
                  "
                  class="pa-1"
                  :class="{ 'text-override': buttonTextColor }">
                  {{ deluge.panels[tab].buttons[i].name }}
                </div>
                <img
                  :src="oneSvg"
                  class="logo-graphic-placeholder"
                  :style="`filter: ${styling.filterColour} !important;`" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PreviewDisplay from '../OnAir/CueTake/PreviewDisplay.vue';
import { onMounted, ref, watch, reactive, onBeforeMount, computed } from 'vue';
import CreatePanelModal from './CreatePanelModal.vue';
import { $http } from '@/stores/http.js';
import { deluge } from '@/stores/deluge.js';
import CreateNewButtonModal from './CreateNewButtonModal.vue';
import oneSvg from '../../assets/OneLightHalf.png';
import CueTakeControls from '../OnAir/CueTakeControls.vue';
import FramesView from './FramesView.vue';
import DeckView from './DeckView.vue';

const props = withDefaults(
  defineProps<{
    Sports?: boolean;
    preview?: boolean;
    tabs?: boolean;
    controls?: boolean;
    preSelect?: string | string[];
    controlPanelMode?: boolean;
    buttonTextColor?: string;
  }>(),
  {
    Sports: false,
    preview: true,
    tabs: true,
    controls: true,
    preSelect: () => [],
    controlPanelMode: false,
  }
);

const viewMode = ref(
  props.controlPanelMode ? localStorage.getItem('cp_viewMode') || 'grid' : 'grid'
);
watch(viewMode, (v) => {
  if (props.controlPanelMode) localStorage.setItem('cp_viewMode', v);
});

const multipleFrames = computed(() => {
  if (!deluge.frames) return false;
  let count = 0;
  for (const frame of Object.values(deluge.frames)) {
    if (frame.did && deluge.channels?.[frame.did]) {
      count++;
      if (count > 1) return true;
    }
  }
  return false;
});

watch(multipleFrames, (multi) => {
  if (!multi && viewMode.value === 'frames') viewMode.value = 'grid';
});
const createPanelOpen = ref(false);
const tab = ref(null);
const createButtonOpen = ref(false);
const selectedPanelIndex = ref(0);
const selectedPanelUid = ref('');
const selectedbtn = ref(undefined);
const selectedPanel = ref(undefined);

function emptyBoxClick(index, selectedBtn = undefined) {
  if (props.controlPanelMode) return;
  selectedPanelIndex.value = index;
  if (tab.value) {
    selectedPanelUid.value = tab.value;
  }
  createButtonOpen.value = true;
  selectedbtn.value = selectedBtn;
}
const loadingState = ref(false);
const draggedIndex = ref(null);

const filteredPanels = computed(() => {
  const allPanels = deluge.panels || {};
  if (Array.isArray(props.preSelect) && props.preSelect.length > 0) {
    const selectedPanelNames = new Set(props.preSelect);
    return Object.fromEntries(
      Object.entries(allPanels).filter(([, panel]) =>
        selectedPanelNames.has(panel.name)
      )
    );
  }
  return allPanels;
});

function checkSelected() {
  if (props.Sports) {
    styling.filterColour =
      'invert(0%) sepia(0%) saturate(7486%) hue-rotate(10deg) brightness(50%) contrast(103%)';
  }
}
const styling = reactive({
  filterColour:
    'invert(0%) sepia(0%) saturate(7486%) hue-rotate(10deg) brightness(50%) contrast(103%)',
});
function getActiveFrames(toCheck) {
  let uuids = [];
  let frameIds = [];
  const toCheckStr = JSON.stringify(toCheck);
  const regex = /"([a-zA-Z0-9-]+)"/g;
  let m;
  while ((m = regex.exec(toCheckStr)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    uuids.push(m[1]);
  }
  for (const frame of Object.values(deluge.frames)) {
    const ch = deluge.channels[frame.did];
    const liveSceneUid = ch?.live_scene?.did;
    const sceneObj = deluge.items[liveSceneUid];
    if (uuids.includes(liveSceneUid) || uuids.includes(sceneObj?.scene_name)) {
      frameIds.push(frame.id);
    }
  }
  return frameIds;
}
function getFramesInUse() {
  if (!deluge.frames) {
    return [];
  }
  let frameIdList = [];
  for (const frame of Object.values(deluge.frames)) {
    if (frame.channel_id) {
      frameIdList.push(frame.id);
    }
  }
  return frameIdList;
}

function handleDragStart(index) {
  draggedIndex.value = index;
}

async function handleDrop(newIndex) {
  const currentIndex = draggedIndex.value;
  if (
    currentIndex !== null &&
    currentIndex !== newIndex &&
    tab.value &&
    deluge.panels[tab.value]
  ) {
    const panelUid = tab.value;
    try {
      await $http(
        'PUT',
        `/move_panel_button?panel_uid=${panelUid}&current_index=${currentIndex}&new_index=${newIndex}`
      );
    } catch (error) {
      console.error('Failed to move button:', error);
    }
  }
  draggedIndex.value = null;
}

async function triggerFromPanel(panelUid, buttonIndex) {
  if (loadingState.value) return;

  if (
    deluge.panels[panelUid] &&
    deluge.panels[panelUid].buttons &&
    deluge.panels[panelUid].buttons[buttonIndex]
  ) {
    deluge.panels[panelUid].buttons[buttonIndex].loading = true;
  }
  loadingState.value = true;
  try {
    await $http(
      'POST',
      `/dynamic_engine/triggers_from_panel?panel_uid=${panelUid}&index=${buttonIndex}`
    );
  } catch (error) {
    console.error('Failed to trigger button:', error);
  }
  loadingState.value = false;
  if (
    deluge.panels[panelUid] &&
    deluge.panels[panelUid].buttons &&
    deluge.panels[panelUid].buttons[buttonIndex]
  ) {
    deluge.panels[panelUid].buttons[buttonIndex].loading = false;
  }
}

watch(
  [() => props.preSelect, () => deluge.panels],
  ([newPreSelect], [oldPreSelect]) => {
    const preSelectChanged =
      JSON.stringify(newPreSelect) !== JSON.stringify(oldPreSelect);

    const panelsToConsider = filteredPanels.value;
    const availablePanelUids = Object.keys(panelsToConsider);

    if (availablePanelUids.length === 0) {
      tab.value = null;
      return;
    }

    const setTabFromPreselect = () => {
      let preferredPanelName = '';
      if (Array.isArray(props.preSelect) && props.preSelect.length > 0) {
        preferredPanelName = props.preSelect[0];
      } else if (typeof props.preSelect === 'string' && props.preSelect) {
        preferredPanelName = props.preSelect;
      }

      if (preferredPanelName) {
        const foundPanel = Object.entries(panelsToConsider).find(
          ([, panel]) => panel.name === preferredPanelName
        );
        if (foundPanel) {
          tab.value = foundPanel[0];
          return true;
        }
      }
      return false;
    };

    if (preSelectChanged || !tab.value || !panelsToConsider[tab.value]) {
      const success = setTabFromPreselect();
      if (!success && (!tab.value || !panelsToConsider[tab.value])) {
        tab.value = availablePanelUids[0];
      }
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

onMounted(async () => {
  checkSelected();
});

onBeforeMount(() => {
  if (props.Sports) {
    styling.filterColour =
      'invert(0%) sepia(0%) saturate(7486%) hue-rotate(10deg) brightness(50%) contrast(103%)';
  }
  checkSelected();
});
</script>
<style>
.v-switch__track {
  border-radius: 10px !important;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  flex-grow: 1;
  overflow-y: auto;
}
.button {
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: start;
  font-size: clamp(1rem, 2vw, 1rem);

  color: white;
  font-family: Montserrat !important;
  flex-grow: 1;

  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px;
  user-select: none;
  transition:
    box-shadow 0.3s ease,
    opacity 0.3s ease,
    outline 0.1s ease-in-out,
    transform 0.1s ease-out;
  outline: 4px solid transparent;
}

.button-background-highlight {
  height: 100%;
  top: 0;
  width: 0%;
  position: absolute;
  left: 16px;
  opacity: 0;
  transition: 0.2s;
  z-index: 1;
  border-radius: 0 8px 8px 0;
}

.button-background-live {
  height: calc(100% - 20px);
  top: 10px;
  width: 100%;
  position: absolute;
  left: 10px;
  transition: 0.2s;
  border-radius: 10px;
  z-index: 1;
}
.button-clickable {
  cursor: pointer;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.button-unavailable {
  cursor: wait;
}
.button-clickable:hover {
  opacity: 1;
}

.button-clickable:hover .button-background-highlight {
  opacity: 0.7;
  width: calc(100% - 16px);
}

.button-clickable:active {
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 4px 8px inset,
    inset 0 0 0 3px var(--button-color, rgb(var(--v-theme-primary)));
}

.button-clickable:hover .coloured-panel {
  opacity: 1;
}

.box {
  background-color: #2a2a2a;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bebebe;
  font-family: Montserrat !important;
  flex-grow: 1;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;

  cursor: pointer;
  user-select: none;
  transition: transform 0.1s ease-out;
}

.box:hover {
  box-shadow:
    rgba(0, 0, 0, 0.15) 0px 4px 6px 0px inset,
    rgba(0, 0, 0, 0.1) 0px 4px 6px;
  color: white;
  background-color: rgb(var(--v-theme-primary)) !important;
}
.managers {
  height: 232px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
}

.coloured-panel {
  height: 100%;
  width: 16px;
  opacity: 0.7;
  border-radius: 6px 0 0 6px;
}

.content-panel {
  height: 100%;
  width: 100%;
  background-color: #cccccc1c;
  display: flex;
  position: relative;
  border-radius: 0 6px 6px 0;
}

.logo-graphic-placeholder {
  height: 100%;
  position: absolute;
  right: 0px;
  opacity: 0.1;

  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  pointer-events: none;
  filter: var(--logo-filter);
}

.button-box {
  display: flex;
  padding: 0px !important;
  overflow: hidden;
  border: 0px;
  background-color: #d2691e00;
  box-shadow: none;
}

.button-box-outer {
  display: flex;
  flex-grow: 1;
  background-color: var(--grid-box-outer);
  padding: 4px;
  border-radius: 8px;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.06) 1px 1px 14px;
  transition:
    box-shadow 0.3s ease,
    opacity 0.3s ease,
    outline 0.1s ease-in-out,
    transform 0.1s ease-out;
  outline: 4px solid transparent;
}

.button-box-outer.is-empty {
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.button-box-outer:has(.control-panel-mode:hover) {
  transform: unset !important;
}
.button-clickable:has(.control-panel-mode:active) {
  pointer-events: none !important;
  transform: unset !important;
  box-shadow: none !important;
  transition: none !important;
}

.button-clickable:hover > .button,
.button-clickable:hover > .box {
  transform: scale(0.96);
}

.button-clickable:active > .button,
.button-clickable:active > .box {
  transform: scale(0.86);
}
</style>

<style scoped>
.text-override {
  color: v-bind(buttonTextColor) !important;
}

.view-mode-group {
  display: flex;
  border-radius: 10px;
  overflow: hidden;
  margin-left: 8px;
  background: rgba(128, 128, 128, 0.12);
}

.view-mode-group .view-mode-btn {
  height: 33px;
  border-radius: 0;
}

.view-mode-group .view-mode-btn:first-child {
  border-radius: 10px 0 0 10px;
}

.view-mode-group .view-mode-btn:last-child {
  border-radius: 0 10px 10px 0;
}
</style>
